export default __webpack_public_path__ + "static/media/nothing-here.8469b2e5.png";